import type { AggregateOffer, UnitPriceSpecification } from "@decocms/apps-commerce/types"
import { formatPrice } from "~/sdk/format"

const bestInstallment = (acc: UnitPriceSpecification | null, curr: UnitPriceSpecification) => {
    if (curr.name === "Visa") {
        return curr
    }

    if (curr.priceComponentType !== 'https://schema.org/Installment') {
        return acc
    }

    if (!acc) {
        return curr
    }

    if (acc.price > curr.price) {
        return curr
    }

    if (acc.price < curr.price) {
        return acc
    }

    if (acc.billingDuration && curr.billingDuration && acc.billingDuration < curr.billingDuration) {
        return curr
    }

    return acc
}

const installmentToString = (installment: UnitPriceSpecification, sellingPrice: number) => {
    const { billingDuration, billingIncrement, price } = installment

    if (!billingDuration || !billingIncrement) {
        return ''
    }

    const withTaxes = sellingPrice < price

    return `<strong>${billingDuration}x</strong> de <strong>${
        formatPrice(billingIncrement)
    }</strong> ${withTaxes ? 'com juros' : 'sem juros'}`
}

export const useOffer = (aggregateOffer?: AggregateOffer) => {
    const offer = aggregateOffer?.offers?.[0]
    const listPrice = offer?.priceSpecification?.find((spec) =>
        spec.priceType === 'https://schema.org/ListPrice'
    )
    const installment = offer?.priceSpecification
        ?.filter((spec) => spec.name === "Visa")
        .reduce(bestInstallment, null as UnitPriceSpecification | null)
    const seller = offer?.seller
    const price = offer?.price
    const availability = offer?.availability

    return {
        price,
        listPrice: listPrice?.price,
        availability,
        seller,
        bestInstallment: installment,
        installments: installment && price ? installmentToString(installment, price) : null,
    }
}
